import React from 'react';
import useStyles from '../useStyles';

import { CustomizedButton, CustomizedTypography } from '@components/Customized';
import { clsx } from '@components/Provider';
import { TabState } from './QuotationDetail/useActiveTab';

import { IButtonProps } from './types';

interface FixedBottomCTAProps {
  className?: string;
  subTitle?: string | undefined;
  buttons: IButtonProps[];
  isWithdrawn?: boolean;
  matches: boolean;
  quotation?: number;
  setActiveTab?: React.Dispatch<React.SetStateAction<TabState>>;
}

const FixedBottomCTA: React.FC<FixedBottomCTAProps> = ({
  children,
  className,
  subTitle = undefined,
  buttons,
  isWithdrawn = false,
  matches,
  quotation
}) => {
  const classes = useStyles();

  return (
    <React.Fragment>
      {children}
      <div className={classes['Dashboard-Right-Action-CTA']}>
        {subTitle && isWithdrawn && (
          <CustomizedTypography variant="body2" color="textSecondary">
            {subTitle}
          </CustomizedTypography>
        )}
        <div className="buttonsContainer">
          {buttons
            .filter((item) => !item.invisibility)
            .map((item, idx) => (
              <CustomizedButton
                key={idx}
                fullWidth={matches}
                disabled={item.disabled || isWithdrawn}
                size="large"
                className={clsx('cta', className)}
                variant={item.variant ?? 'contained'}
                color={item.color ?? 'default'}
                onClick={item.action}
              >
                <i
                  className={
                    item.label === '발주하기'
                      ? 'request-gtm-purchaseOrder-btn'
                      : ''
                  }
                >
                  {item.label}
                </i>
              </CustomizedButton>
            ))}
        </div>
      </div>

      <div
        className={clsx(classes['Dashboard-Right-Action-CTA'], {
          block: true
        })}
      />
    </React.Fragment>
  );
};

export default FixedBottomCTA;
